import {ActionsManager} from "./actions/actionsManager";
import {ValidationManager} from "./validations/validationManager";
import {utils_ui} from "./utils/utils_ui";
import {store} from "../redux/storeConfig/store";
import {utils_log} from "./utils/utils_log";

export class ApplyooNS {
    static saveLocalStorageToDBManagerInstance: any = null;

    static dicComponentHandlers:any = {}
    static dicComponentStatistics:any = {}
    static dicDataStore:any = {}
    // static actionsManagerObj:any = {}
    static dicEventListeners:any = {}

    static actionsManagerObj:any = new ActionsManager();

    static dicCurrentLanguageTitles:any = {};
    static selectedProject:any = {};

    static validationManagerObj = new ValidationManager();
    static  C_MaxFilterFieldItemsToShowAvatars = 8

    static clearMemory()
    {
        utils_ui.deleteObjectProperties(ApplyooNS.dicComponentHandlers)
        utils_ui.deleteObjectProperties(ApplyooNS.dicComponentStatistics)
        utils_ui.deleteObjectProperties(ApplyooNS.selectedProject)
        utils_ui.deleteObjectProperties(ApplyooNS.dicEventListeners)
    }

    static sendComponentNotification(prmTargetElementGuid:string, prmTargetSubComponent:string, prmParams?:any) {
        let targetElement = prmTargetElementGuid;

        if (!!prmTargetSubComponent){
            targetElement = `${prmTargetElementGuid}_${prmTargetSubComponent}`
        }

        //console.log(ApplyooNS.dicComponentHandlers[targetElement])

        //let xx:any = ApplyooNS.getComponentHandlersByElementID(targetElement)

        if (prmTargetSubComponent == "*") {
            if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
                for (const currElementKey in ApplyooNS.dicComponentHandlers) {
                    if (prmTargetElementGuid != currElementKey
                        && currElementKey.startsWith(`${prmTargetElementGuid}_`)
                        && !!ApplyooNS.dicComponentHandlers[currElementKey]?.onSendComponentNotification) {
                        ApplyooNS.dicComponentHandlers[currElementKey].onSendComponentNotification(prmParams)
                    }
                }
            }
        }
        else {
            if (!!ApplyooNS && !!ApplyooNS.dicComponentHandlers){
                if (!!ApplyooNS.dicComponentHandlers[targetElement]
                    && !!ApplyooNS.dicComponentHandlers[targetElement]["onSendComponentNotification"]){
                    ApplyooNS.dicComponentHandlers[targetElement]["onSendComponentNotification"](prmParams)
                }
            }

        }
    }

    static addComponentHandler(prmElementID:any, prmElementObj:any) {
        ApplyooNS.dicComponentHandlers[prmElementID] = prmElementObj
        ApplyooNS.addComponentStatistics(prmElementID)
    }

    static removeComponentHandler(prmElementID:any) {
        utils_log.writeToLog(`***removeComponentHandler - ${prmElementID}`)

        let lstRelatedComponentKeys = Object.keys(ApplyooNS.dicComponentHandlers).filter((prmComponentKey:any) => {
            return prmComponentKey.startsWith(prmElementID)
        })

        for (const currComponentKey of lstRelatedComponentKeys) {
            if (!!ApplyooNS.dicComponentHandlers[currComponentKey]) {
                delete  ApplyooNS.dicComponentHandlers[currComponentKey]
                delete ApplyooNS.dicComponentStatistics[currComponentKey]
            }
        }

    }

    static addComponentAlias(prmElementID:any, prmElementObj:any) {
        ApplyooNS.dicComponentHandlers[prmElementID] = prmElementObj
        ApplyooNS.addComponentStatistics(prmElementID)
    }

    static addComponentStatistics(prmElementID:any) {
        if (!!ApplyooNS.dicComponentStatistics[prmElementID]){
            ApplyooNS.dicComponentStatistics[prmElementID]["Render"]++;
        }
        else {
            ApplyooNS.dicComponentStatistics[prmElementID] = {
                Render: 1
            }
        }
    }

    // dispose() {
    //     console.log('Cleaning up resources');
    // //     utils_ui.deleteObjectProperties(ApplyooNS.dicComponentHandlers)
    // //     utils_ui.deleteObjectProperties(ApplyooNS.dicComponentStatistics)
    // //     //static dicDataStore:any = {}
    // //     //static dicEventListeners:any = {}
    // //
    // //     utils_ui.deleteObjectProperties(ApplyooNS.actionsManagerObj)
    // //
    // // // static dicCurrentLanguageTitles:any = {};
    // //     utils_ui.deleteObjectProperties(ApplyooNS.selectedProject)
    // //     store.dispatch({ type: 'FREE_MEMORY' })
    // }
}

export const dicKnownFileExtensions:any = {
    ".xlsx": {
        icon: "fa fa-file-excel-o",
        iconCss: "excel-file",
        extensionName: "Excel Spreadsheet"
    },

    ".xls": {
        icon: "fa fa-file-excel-o",
        iconCss: "excel-file",
        extensionName: "Excel Spreadsheet"
    },

    ".docx": {
        icon: "fa fa-file-word-o",
        iconCss: "word-file",
        extensionName: "Word Document"
    },

    ".doc": {
        icon: "fa fa-file-word-o",
        iconCss: "word-file",
        extensionName: "Word Document"
    },
    ".pptx": {
        icon: "fa fa-file-powerpoint",
        iconCss: "file-powerpoint",
        extensionName: "Power Point"
    },

    ".ppt": {
        icon: "fa fa-file-powerpoint",
        iconCss: "file-powerpoint",
        extensionName: "Power Point"
    },
    ".pdf": {
        icon: "fa fa-file-pdf-o",
        iconCss: "pdf-file",
        extensionName: "Pdf"
    },
    ".txt": {
        icon: "fa fa-file-text-o",
        iconCss: "txt-file",
        extensionName: "Text File"
    },

}

export const lstImageFileExtensions = ['.bmp', '.ico', '.gif', '.png', '.jpg', '.jpeg', '.svg', '.webp']

export const lstMonth = [
    {value:"1" , label: 'Title_January'},
    {value:"2" , label: 'Title_February'},
    {value:"3" , label: 'Title_March'},
    {value:"4" , label: 'Title_April'},
    {value:"5" , label: 'Title_May'},
    {value:"6" , label: 'Title_June'},
    {value:"7" , label: 'Title_July'},
    {value:"8" , label: 'Title_August'},
    {value:"9" , label: 'Title_September'},
    {value:"10" , label: 'Title_October'},
    {value:"11" , label: 'Title_November'},
    {value:"12" , label: 'Title_December'}
]

export const lstWeekDay = [
    {value:"1" , label: 'Title_Sunday'},
    {value:"2" , label: 'Title_Monday'},
    {value:"3" , label: 'Title_Tuesday'},
    {value:"4" , label: 'Title_Wednesday'},
    {value:"5" , label: 'Title_Thursday'},
    {value:"6" , label: 'Title_Friday'},
    {value:"7" , label: 'Title_Saturday'}
]

export enum eLogicTypes{
    Greater = 1,
    Less = 2,
    Equals = 3,
    Between = 4,
    GreaterOrEquals = 5,
    LessOrEquals = 6,
    NotEquals = 7,
}